export default __webpack_public_path__ + "static/media/milk.65092895.svg";